export default "__VITE_ASSET__zxzkpRQm__"